import styled from 'styled-components';
import { FONTS, SIZE, COLORS } from '@app/src/ui';

interface Props {
  isBold?: boolean;
}

export const Wrapper = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  margin: 20px 0;
`;

Wrapper.displayName = 'Wrapper';

export const Channel = styled.div`
  font-weight: bold;
  font-size: 16px;
`;

Channel.displayName = 'Channel';

export const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 7px 0 20px;

  @media(min-width: ${SIZE.TABLET_BREAK}) {
    margin: 20px 0;
  }
`;

Box.displayName = 'Box';

export const Day = styled.span`
  font-weight: bold;
  font-size: 13px;

  @media(min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }
`;

Day.displayName = 'Day';

export const Preview = styled.div`
  width: 100%;
  margin-bottom: 7px;

  @media(min-width: ${SIZE.TABLET_BREAK}) {
    width: 240px;
    margin: 0;
    padding-right: 26px;
  }
`;

Preview.displayName = 'Preview';

export const Text = styled.span`
  font-size: 13px;
  font-weight: ${(props: Props) =>
    props.isBold && 'bold'};

  @media(min-width: ${SIZE.TABLET_BREAK}) {
    font-size: 14px;
  }
`;

Text.displayName = 'Text';

export const TextBox = styled.div`
  padding: 4px 9px;
  box-sizing: border-box;
  border: 1px solid #BBBBBB;
  color: #000000;
  text-align: justify;
  ${Text} {
    font-size: 12px;
  }
`;

TextBox.displayName = 'TextBox';

export const Summary = styled.div`
  width: 100%;

  @media(min-width: ${SIZE.TABLET_BREAK}) {
    width: calc(100% - 240px);
  }
`;

Summary.displayName = 'Summary';

export const SummaryTitle = styled.div`
  font-size: 11px;
  color: ${COLORS.GRAY_TEXT};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 12px;
  }
`;

SummaryTitle.displayName = 'SummaryTitle';

export const SummaryDescription = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  font-size: 12px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

SummaryDescription.displayName = 'SummaryDescription';

export const TextDescription = styled.div`
  font-weight: ${(props: Props) =>
    props.isBold && 'bold'};
`;

TextDescription.displayName = 'TextDescription';

export const Line = styled.div`
  width: 100%;
  background-color: ${COLORS.GRAY_LIGHT};
  height: 1px;
  margin: 4px 0;
`;

Line.displayName = 'Line';
